module.exports = __webpack_public_path__ + "img/system_cn.acedb8cc.png";